import { SdkBundleRow } from "src/settings/sdks/types";

const FINGERPRINT_ICON = `${import.meta.env.BASE_URL}providerIcons/FingerprintIcon.svg`;
const SOCURE_ICON = `${import.meta.env.BASE_URL}providerIcons/SocureIcon.svg`;

export const MOCK_SDK_BUNDLES: SdkBundleRow[] = [
  {
    id: "bnd-strict-device-intelligence",
    name: "Strict device intelligence",
    scripts: [
      {
        id: "script-fingerprint",
        name: "Fingerprint",
        iconSrc: FINGERPRINT_ICON,
      },
      {
        id: "script-socure-di",
        name: "Socure Digital Intelligence",
        iconSrc: SOCURE_ICON,
      },
    ],
    lastUpdatedLabel: "Nov 11, 2024 at 1:37 pm",
    createdAtLabel: "Nov 11, 2024 at 1:37 pm",
  },
  {
    id: "bnd-fingerprint",
    name: "Fingerprint",
    scripts: [
      {
        id: "script-fingerprint",
        name: "Fingerprint",
        iconSrc: FINGERPRINT_ICON,
      },
    ],
    lastUpdatedLabel: "Nov 11, 2024 at 1:37 pm",
    createdAtLabel: "Nov 11, 2024 at 1:37 pm",
  },
  {
    id: "bnd-socure",
    name: "Socure",
    scripts: [
      {
        id: "script-socure-di",
        name: "Socure Digital Intelligence",
        iconSrc: SOCURE_ICON,
      },
    ],
    lastUpdatedLabel: "Nov 11, 2024 at 1:37 pm",
    createdAtLabel: "Nov 11, 2024 at 1:37 pm",
  },
];
